<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">The Greek Victories and the Persian Ebb 480–479 <span class="smallcaps">BC</span></p>
<a id="page_ii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?dd3ba7fc